module.exports = __webpack_public_path__ + "img/IMG_5890.2f2a6e67.jpg";